module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-alerts-panel.8d789481.png";